import { render, staticRenderFns } from "./IconLabel.vue?vue&type=template&id=67b46bdf"
import script from "./IconLabel.vue?vue&type=script&lang=js"
export * from "./IconLabel.vue?vue&type=script&lang=js"
import style0 from "./IconLabel.vue?vue&type=style&index=0&id=67b46bdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports